import Swal from 'sweetalert2'

const toastMixin = Swal.mixin({
  toast: true,
  animation: true,
  position: 'top-start',
  showConfirmButton: false,
  showCloseButton: true,
  timer: 4000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  }
})

export function useToast() {
  const showToast = (message: string, type: 'success' | 'error' | 'warning' | 'info' = 'success') => {
    return toastMixin.fire({
      icon: type,
      title: message
    })
  }

  return {
    showToast
  }
} 